import { apiURL } from "../../../config";
import { DownloadLink } from "../../DownloadLink/DownloadLink";
import { PropTypes } from "prop-types";
import { StyledDirectionTable } from "../../../styles/StyledDecision/StyledContent";
import DeleteIcon from "../../../assets/img/icons/delete.svg";
import { useState } from "react";
import { StyledModal } from "../../../styles/StyledModal";
import Modal from "react-modal";
import { theme } from "../../../styles/theme";

export default function DecisionAttachment({ data, setDeletedId, openModal }) {
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);
	const [previewUrl, setPreviewUrl] = useState("");

	// Handle both real attachments and temporary attachments
	const isTemporary = data.tempId || !data.file?.url;
	let downloadUrl = "";
	let filename = "";

	if (!isTemporary && data.file?.url) {
		const path = data.file.url.split("/");
		filename = path[path.length - 1];
		// The backend FileController expects /content/file/{collection}/{key} without extension
		// data.file.url is like "/content/file/attachments/keyname.pdf"
		// Remove the file extension to match the backend route
		downloadUrl = apiURL + data.file.url.replace(/\.[^/.]+$/, "");
		
		console.log("🔍 Download URL Debug:", {
			originalFileUrl: data.file.url,
			filename: filename,
			constructedDownloadUrl: downloadUrl,
			apiURL: apiURL,
			attachmentId: data.id,
			attachmentData: data
		});
	} else if (data.file?.name) {
		filename = data.file.name;
	} else if (data.file?.fileName) {
		filename = data.file.fileName;
	}



	// Check if file is an image that can be previewed
	const isPreviewableImage = () => {
		const imageTypes = ["image/png", "image/jpg", "image/jpeg", "image/gif"];
		const imageExtensions = ["png", "jpg", "jpeg", "gif"];
		
		// For temporary files (from upload), check the file.type property
		if (data.file?.type) {
			return imageTypes.includes(data.file.type.toLowerCase());
		}
		
		// For saved files from API, check fileType field
		if (data.file?.fileType) {
			return imageTypes.includes(data.file.fileType.toLowerCase());
		}
		
		// For saved files from API, check fileExtension field
		if (data.file?.fileExtension) {
			return imageExtensions.includes(data.file.fileExtension.toLowerCase());
		}
		
		// Fallback: check filename extension
		if (filename) {
			const extension = filename.toLowerCase().split(".").pop();
			return imageExtensions.includes(extension);
		}
		
		return false;
	};

	const handlePreview = () => {
		if (isTemporary && data.tempFile) {
			// For temporary files, create a blob URL
			const blobUrl = URL.createObjectURL(data.tempFile);
			setPreviewUrl(blobUrl);
		} else {
			// For saved files, use the download URL
			setPreviewUrl(downloadUrl);
		}
		setIsPreviewOpen(true);
	};

	const closePreview = () => {
		setIsPreviewOpen(false);
		// Clean up blob URL if it was created
		if (previewUrl && previewUrl.startsWith("blob:")) {
			URL.revokeObjectURL(previewUrl);
		}
		setPreviewUrl("");
	};

	return (
		<>
			<StyledDirectionTable sizes={[30, 30, 20, 20]}>
				<span>{data.name}</span>
				<span>{data.description}</span>
				<span>
					{isTemporary ? (
						<span style={{ fontStyle: "italic", color: "#666" }}>
							Available after saving
						</span>
					) : (
						<DownloadLink url={downloadUrl} filename={filename}>
							Download
						</DownloadLink>
					)}
					{isPreviewableImage() && (
						<button
							onClick={handlePreview}
							style={{
								marginLeft: "8px",
								padding: "4px 12px",
								background: theme.color.green,
								color: theme.color.white,
								border: "none",
								borderRadius: "4px",
								cursor: "pointer",
								fontSize: "12px",
								fontWeight: "500",
								fontFamily: theme.font.secondary,
								textTransform: "uppercase",
								letterSpacing: "0.025em",
								transition: "all 0.2s ease"
							}}
							onMouseEnter={(e) => {
								e.target.style.background = "#2d9a75";
								e.target.style.transform = "translateY(-1px)";
							}}
							onMouseLeave={(e) => {
								e.target.style.background = theme.color.green;
								e.target.style.transform = "translateY(0)";
							}}
						>
							Preview
						</button>
					)}
				</span>
				<span>
					<img
						onClick={() => {
							setDeletedId(data.id);
							openModal();
						}}
						src={DeleteIcon}
						alt={DeleteIcon}
						role="img"
					/>
				</span>
			</StyledDirectionTable>

			{/* Image Preview Modal */}
			<Modal
				isOpen={isPreviewOpen}
				onRequestClose={closePreview}
				style={{
					overlay: {
						backgroundColor: "rgba(0, 0, 0, 0.8)",
						zIndex: 1000
					},
					content: {
						top: "50%",
						left: "50%",
						right: "auto",
						bottom: "auto",
						marginRight: "-50%",
						transform: "translate(-50%, -50%)",
						padding: "20px",
						border: "none",
						borderRadius: "8px",
						maxWidth: "90vw",
						maxHeight: "90vh"
					}
				}}
			>
				<div style={{ textAlign: "center" }}>
					<h3 style={{ 
						marginBottom: "16px", 
						color: theme.color.black,
						fontFamily: theme.font.primary,
						fontWeight: "600"
					}}>
						{data.name}
					</h3>
					<img
						src={previewUrl}
						alt={data.name}
						style={{
							maxWidth: "100%",
							maxHeight: "70vh",
							objectFit: "contain",
							borderRadius: "8px",
							boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
						}}
					/>
					<div style={{ marginTop: "16px" }}>
						<button
							onClick={closePreview}
							style={{
								padding: "8px 16px",
								background: theme.color.gray,
								color: theme.color.white,
								border: "none",
								borderRadius: "4px",
								cursor: "pointer",
								fontFamily: theme.font.secondary,
								fontWeight: "500",
								transition: "all 0.2s ease"
							}}
							onMouseEnter={(e) => {
								e.target.style.background = theme.color.gray0;
							}}
							onMouseLeave={(e) => {
								e.target.style.background = theme.color.gray;
							}}
						>
							Close
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
}

DecisionAttachment.propTypes = {
	data: PropTypes.any,
	setDeletedId: PropTypes.func,
	openModal: PropTypes.func,
};
